export const toPrismaJsonInput = <T, TDbNull>(
  input: T | null | undefined,
  dbNull: TDbNull,
): T | undefined | TDbNull => {
  if (input === undefined) {
    return undefined;
  }
  if (input === null) {
    return dbNull;
  }
  return input;
};
